export function formTypeShortLabel(type: Forms.FormType): string {
	if (type === 'EMPLOYEE_NR1') return 'NR1';
	if (type === 'CBI') return 'CBI';
	return type;
}

export function formatDatePt(iso: string): string {
	try {
		const d = new Date(iso);
		if (Number.isNaN(d.getTime())) return '—';
		return d.toLocaleDateString('pt-BR', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
		});
	} catch {
		return '—';
	}
}

export function formatPeriodRangeLabel(
	startsAt: string,
	endsAt: string,
): string {
	return `${formatDatePt(startsAt)} – ${formatDatePt(endsAt)}`;
}

/** PNG do painel/relatório (admin e portal `/empresa/dashboard`). */
export async function downloadCompanyDashboardReportPng(
	reportRoot: HTMLElement,
): Promise<void> {
	const { toPng } = await import('html-to-image');
	if (typeof document !== 'undefined' && 'fonts' in document) {
		await (document as Document & { fonts: { ready: Promise<unknown> } })
			.fonts.ready;
	}
	await new Promise((resolve) => window.setTimeout(resolve, 120));

	const dataUrl = await toPng(reportRoot, {
		cacheBust: true,
		backgroundColor: '#ffffff',
		pixelRatio: Math.min(3, window.devicePixelRatio || 2),
	});

	const now = new Date();
	const stamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(
		2,
		'0',
	)}${String(now.getDate()).padStart(2, '0')}-${String(
		now.getHours(),
	).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
	const link = document.createElement('a');
	link.href = dataUrl;
	link.download = `relatorio-empresa-${stamp}.png`;
	link.click();
}
